function load_cart(data_remove_line){
  fetch(window.Shopify.routes.root +'?section_id=cart-drawer')
  .then((response) => response.text())
  .then((responseText) => {
    const cartid = 'cart-drawer';
    const html = new DOMParser().parseFromString(responseText, 'text/html')  
    const destination = document.querySelector('.cart-sidebar');
    const source = html.getElementById(cartid);
    if (source && destination) destination.innerHTML = source.innerHTML;
    initUSPCarousel();
    // document.querySelectorAll('.item-remove').forEach(function(cartRemove){
    //   cartRemove.addEventListener('click',(evt) => {
    //     evt.preventDefault();
    //     var data_line = cartRemove.dataset.line;
    //     // alert(data_line)
    //     removeItem(data_line,cartRemove)
    //     // removeItem(data_line)
    //   });
    // });
    document.querySelectorAll('.header-cart button').forEach(function(cartButton){
      cartButton.addEventListener('click',function(e){
        document.querySelector(".cart_popup").innerHTML = '';
        document.querySelector('body').classList.add('open-drawer');
        document.querySelector('body').classList.remove('open-menu','open-search','open-sort','open-filter','open-wishlist');
      });
    });
    document.querySelectorAll('.overlay-box,.cart-drawer-close button').forEach(function(cartButton){
      cartButton.addEventListener('click',function(e){
        document.querySelector('body').classList.remove('open-drawer','open-menu','open-search','open-sort','open-filter','open-wishlist');
      });
    });
    const url = '/cart.js';
    fetch(url)
    .then((resp) => resp.json())
    .then(function(data) {
      var cart_count = data.item_count;
      if(cart_count>0){
        if(document.querySelectorAll('.item-row[data-properties]').length > 0){
          document.querySelector('.cart-count').innerHTML = cart_count - document.querySelectorAll('.item-row[data-properties]').length;
        }else{
          document.querySelector('.cart-count').innerHTML = cart_count;
        }
      }else{
      	document.querySelector('.cart-count').innerHTML = '';
      }
    })
    .catch(function(error) {
      console.log(error);
    })
  });
}
load_cart();
$(document).on('click','.item-remove',function(e){
  e.preventDefault();
  let data_line = $(this).attr('data-line');
  const data = {'line': data_line ,'quantity': 0 };
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
  .then((response) => response.json())
  .then((data) => {
    if($(this).parents('.item-row').hasClass('has-gift')){
      let thisID = $(this).parents('.has-gift').getAttribute('data-id');
      let get_property = document.querySelector('.item-row[data-properties="'+ thisID +'"]').getAttribute('data-properties')
      let giftID = document.querySelector('.item-row[data-properties="'+ thisID +'"]').getAttribute('data-id')
      let giftLine = document.querySelector('.item-row[data-properties="'+ thisID +'"] .item-remove').getAttribute('data-line')
      if(thisID == get_property){
        let dataVal = {'line': giftLine ,'quantity': 0 };
        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(dataVal),
        })
        .then((response) => response.json())
        .then((data) => {
          if(document.location.href.indexOf('/cart') > -1) {
            // window.location.href = "/cart";
            $('.cart-wrap').load('/cart' + ' .cart-wrap .cart-section', function(){
              window.history.pushState({}, null, '/cart');  
            });
          }else{
            load_cart();
          }
        })
        .catch((error) => {
          console.log('Error:', error);
        });
      }
    }else{
      if(document.location.href.indexOf('/cart') > -1) {
        // window.location.href = "/cart";
        $('.cart-wrap').load('/cart' + ' .cart-wrap .cart-section', function(){
          window.history.pushState({}, null, '/cart');  
        });
      }else{
        load_cart();
      }
      // load_cart();
    }
    if(document.location.href.indexOf('/cart') > -1) {
      // window.location.href = "/cart";
      $('.cart-wrap').load('/cart' + ' .cart-wrap .cart-section', function(){
        window.history.pushState({}, null, '/cart');  
      });
    }else{
      load_cart();
    }
  })
  .catch((error) => {
    console.error('Error1:', error);
  });
})
// function removeItem(data_line,cartRemove){
//   const data = {'line': data_line ,'quantity': 0 };
//   fetch('/cart/change.js', {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json',
//     },
//     body: JSON.stringify(data),
//   })
//   .then((response) => response.json())
//   .then((data) => {
//     if(cartRemove.closest('.has-gift')){
//       let thisID = cartRemove.closest('.has-gift').getAttribute('data-id');
//       let get_property = document.querySelector('.item-row[data-properties="'+ thisID +'"]').getAttribute('data-properties')
//       let giftID = document.querySelector('.item-row[data-properties="'+ thisID +'"]').getAttribute('data-id')
//       let giftLine = document.querySelector('.item-row[data-properties="'+ thisID +'"] .item-remove').getAttribute('data-line')
//       if(thisID == get_property){
//         let dataVal = {'line': giftLine ,'quantity': 0 };
//         fetch('/cart/change.js', {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify(dataVal),
//         })
//         .then((response) => response.json())
//         .then((data) => {
//           if(document.location.href.indexOf('/cart') > -1) {
//             // window.location.href = "/cart";
//             $('.cart-wrap').load('/cart' + ' .cart-wrap .cart-section', function(){
//               window.history.pushState({}, null, '/cart');  
//             });
//           }else{
//             load_cart();
//           }
//         })
//         .catch((error) => {
//           console.log('Error:', error);
//         });
//       }
//     }else{
//       if(document.location.href.indexOf('/cart') > -1) {
//         // window.location.href = "/cart";
//         $('.cart-wrap').load('/cart' + ' .cart-wrap .cart-section', function(){
//           window.history.pushState({}, null, '/cart');  
//         });
//       }else{
//         load_cart();
//       }
//       // load_cart();
//     }
//     if(document.location.href.indexOf('/cart') > -1) {
//       // window.location.href = "/cart";
//       $('.cart-wrap').load('/cart' + ' .cart-wrap .cart-section', function(){
//         window.history.pushState({}, null, '/cart');  
//       });
//     }else{
//       load_cart();
//     }
//   })
//   .catch((error) => {
//     console.error('Error1:', error);
//   });
// }
$(document).ready(function(){
  $(document).on('click','.add-disc .add-desc-inner',function(e){
    $(this).hide();
    $('.drawer-footer').addClass('active');
    $('.cp-right-inr').addClass('active');
  });
});

function initUSPCarousel() {
  const uspCarousel = document.querySelector('.usps--carousel');
  const uspCarouselInner = uspCarousel?.querySelector('.usps__track');

  if (!uspCarousel || !uspCarouselInner) return;

  uspCarousel.classList.add('usps--active');

  const originalItems = Array.from(uspCarouselInner.children);

  let contentWidth = uspCarouselInner.scrollWidth;
  const containerWidth = uspCarousel.offsetWidth;

  // Keep cloning until we have enough content to loop smoothly
  while (contentWidth < containerWidth * 2) {
    originalItems.forEach(item => {
      const clone = item.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      uspCarouselInner.appendChild(clone);
    });

    contentWidth = uspCarouselInner.scrollWidth;
  }
}